import {Injectable}                         from '@angular/core';
import {HttpClient, HttpHeaders}            from "@angular/common/http";

import {AngularQuery}                       from "../query/angularquery";
import {Position}                           from "./position";

import {Observable}                         from "rxjs/Observable";
import {map} from "rxjs/operators";


@Injectable()
export class PositionService {

	/**
	* Initialize the object.
	*
	* @param {HttpClient} http  Connection to HTTP.
	*/
	constructor(protected http: HttpClient) {}


	/**
	 * Delete the Position associated with the specified ID number.
	 *
	 * @param {number} id  The ID of the Position to delete.
	 * @returns {Observable<Boolean>} Whether the delete was successful or not.
	 */
	deletePosition(id:number): Observable<Boolean> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_POSITION, id.toString());
		query.useParams(false);
		query.useCacheBuster(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Get an array of sport-specific Position objects.
	 *
	 * @param code       The sport the position is associated with ('NFL').
	 * @returns {Observable<Source>}  An Observable<Source> object or error.
	 */
	getPositionsForSelect(code: string): Observable<Position[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_POSITION);
		query.addParameter("code", code);
		query.addParameter('code', 'ALL'); // Make sure the 'None' choice is always there.
		query.addParameter("order_field", "priority");
		let url = query.getUrl();

		return this.http
			.get<Position[]>(url);

	}


	/**
	 * Save the provided Position information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<Position>}  The saved Position data echoed back.
	 */
	save(url: string, json: string): Observable<Position> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Position>(url, json, { headers: headers });

	}


}



// WEBPACK FOOTER //
// ./src/app/services/position/position.service.ts